const isEmail = require('./isEmail')
const isPhone = require('./isPhone')
const checkName = require('./checkName')
const plainName = require('./plainName')

module.exports = {
    isEmail,
    isPhone,
    checkName,
    plainName
}